var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h2',[_vm._v("Funciones de administración")]),_c('div',[_c('documents')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }